import * as React from "react";

function DivLanguage({ children, language, ...other }) {

    if (language !== document.documentElement.lang) {
        return null;
    }

    return (
        <div {...other}>
            {children}
        </div>
    );
}

export default DivLanguage;